<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog v-if="dialogVisible" :title="type==1?'批量调整SKU':'批量调整预付款'" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="400px" :before-close="cancle">
			<div>
				<el-form label-position="right" size="small" ref="ruleForm" label-width="90px">
					<el-form-item label="销售范围:" class="mt15" v-show="type==1">
						<el-select v-model="skuValue" multiple class="w190" size="small" placeholder="选择">
							<el-option v-for="item in skuList" :key="item.skuId" :label="item.skuName"
								:value="item.skuId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否预付款:" class="mt15" v-show="type==2">
						<el-select v-model="advancesFlag" class="w190" size="small" placeholder="选择">
							<el-option label="预付款" value="Y">
							</el-option>
							<el-option label="非预付款" value="N">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			selectAttribute: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				dialogVisible: false,
				advancesFlag: "",
				ruleForm: {},
				type: null,
				skuList: [],
				skuValue: [],
				rows: [],
				sku: [],
			}
		},
		created() {

		},
		methods: {
			init(data, rows) {
				this.dialogVisible = true
				this.$nextTick(() => {
					this.advancesFlag = ""
					this.skuValue = []
					
					this.type = data
					this.rows = rows
					if (data == 1) {
						this.getSkuList()
					}
				})
			},
			getSkuList() {
				let that = this;
				that.$request.post(
						"skuList",
						true, {}
					)
					.then((res) => {
						if (res) {
							that.skuList = res.data
						}
					})
			},
			// 批量修改
			setBatchUpdate() {
				let that = this;
				let agentIds = []
				that.rows.forEach(item => {
					agentIds.push(item.agentId)
				});
				that.$request.post(
						"agentBatchUpdate",
						true, {
							agentIds: agentIds,
							sku: that.sku,
							advancesFlag: that.advancesFlag,
						}
					)
					.then((res) => {
						if (res.code==0) {
							this.dialogVisible = false
							this.$emit("getList")
						}
					})
			},
			// 保存
			submitForm() {
				// sku范围
				if (this.type == 1) {
					this.sku = []
					this.skuList.forEach(item => {
						this.skuValue.forEach(ele => {
							if (ele == item.skuId) {
								this.sku.push({
									skuId: item.skuId,
									skuName: item.skuName
								})
							}
						});
					});
				}
				this.setBatchUpdate()
			},
			// 取消
			cancle() {
				this.$emit('handleBatch');
				this.dialogVisible = false;
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}
	}

</style>
